import React from 'react';
import { Modal } from 'semantic-ui-react';
import ImgPopupFimAnoModal from '../../../../resources/imgs/popup-horario-fim-de-ano.png';

interface HolidayNoticeModalInterface {
  open: boolean;
  onClose: () => void;
}

const HolidayNoticeModal = ({ open, onClose }: HolidayNoticeModalInterface) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      size="small"
      closeOnEscape={true}
      closeOnTriggerClick={true}
      closeOnDocumentClick={false}
      closeOnDimmerClick={true}
      style={{ width: '500px', height: '705px', padding: '0', borderRadius: '8px' }}
      closeIcon
    >
      <Modal.Content
        style={{ width: '500px', height: '705px', padding: '0', borderRadius: '8px' }}
      >
        <img src={ImgPopupFimAnoModal} style={{ width: '500px', height: '705px' }} />
      </Modal.Content>
    </Modal>
  );
};

export default HolidayNoticeModal;
